import { Heading, Center, VStack, Show, Text } from '@chakra-ui/react';
import { RiCopyrightFill } from 'react-icons/ri';

const FalseSiteFooter = ({stateProps}) => {
  const currentYear = new Date().getFullYear();
  return (
    <Center pb={6}>
      <Show breakpoint="(max-width: 767px)">
        <Heading variant="footer" display='flex' justifyContent='center'>
          <Text marginRight='.5rem'><RiCopyrightFill /></Text>
          <Text>Copyright {currentYear} | Resume Scripter, LLC.</Text>
        </Heading>
        <Heading variant="footer" display='flex' justifyContent='center'>Portland, Oregon</Heading>
      </Show>
      <Show breakpoint="(min-width: 768px)">
        <Heading variant="footer" display='flex' justifyContent='center' >
          <Text color="ORANGE_TEXT" marginRight='.5rem'><RiCopyrightFill /></Text>
          <Text color="ORANGE_TEXT">Copyright {currentYear} | Resume Scripter, LLC. </Text>
        </Heading>
        <Heading variant="footer" display='flex'  color="ORANGE_TEXT" justifyContent='center'>&nbsp; Portland, Oregon</Heading>
      </Show>
    </Center>
  );
};

export default FalseSiteFooter;
